import { FileChatMarker, GroupStatusEvent, useIM } from '@wui/im'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useChatFilesMarkersStore = defineStore('chat-files-markers', () => {
  const filesMarkersByPServedMap = ref(new Map<string, FileChatMarker>())

  const { onConferenceUpdated } = useIM()
  onConferenceUpdated((event: GroupStatusEvent) => {
    const { pServed, extendedParams: { fileChatMarker }} = event
    if (fileChatMarker) {
      filesMarkersByPServedMap.value.set(pServed, fileChatMarker)
    }
  })

  return {
    filesMarkersByPServedMap,
  }
})
